import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-resolve-button',
  templateUrl: './resolve-button.component.html',
  styleUrls: ['./resolve-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResolveButtonComponent {
  @Input()
  tooltipTranslationText: string;

  @Input()
  isDisabled = false;

  @Input()
  placement = 'top-right';

  @Input()
  isResolveSingleThreadButton: boolean;
}
